<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Forward Contact Requests To</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

                <v-btn
                    dark
                    text
                    @click="onClickDoNotForward"
                >
                    Do Not Forward
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

              <v-text-field
                label="Search"
                prepend-icon="mdi-magnify"
                style="margin-top: 15px;"
                v-model="full_text"
                v-on:input="update"
                autocomplete="off"
            />


            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                style="margin-top: 15px; margin-bottom: 25px;"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"

                v-on:click:row="onClickRow"
            >
            

            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            full_text: null,
            results: [],

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Internal Label', value: 'internal_label'},
                { text: 'Help With', value: 'help_with'},
            ],
        }
    },

    mounted () {
    },

    methods: {

        update: _.debounce(function(){
            
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST-LABELS: /api/v1/inboxes',
            
                {
                    'full_text' : this.full_text,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.results = data.results;

                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to list inboxes');
                },
            );

        }, 751),
        

        showDialog()
        {
            this.dialog = true;
            this.update();
        },

        closeDialog()
        {
            this.dialog = false;
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        onClickDoNotForward()
        {
            this.closeDialog();
            this.$emit('ok', null);
        },

        onClickRow(row)
        {
            this.closeDialog();
            this.$emit('ok', row.inbox_id);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>